
 const broker_API = {
    getAvailableCompanies () {
      return `/broker/getAvailableMortgageCompanies`;
    },
    getBrokerSettings () {
      return "/broker/getBrokerSettings";
    },
    saveBrokerCorrespondent(){
       return "/broker/saveBrokerCorrespondent";
    },
    saveBrokerCompanies(){
      return "/broker/saveBrokerCompanies";
    },
    register() {
      return "/broker/register-broker";
    }
};
  export { broker_API };